export default __webpack_public_path__ + "static/media/12_leotie_mellody_goforth.1b5e1bec.jpg";